var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 775.14 194.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7ccbc3;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "559.95 30.67 542.18 0 578.73 63.06 615.99 0 559.95 30.67"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "615.99 0 578.73 63.06 634.19 31.53 615.99 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "689.94 0 615.99 0 634.19 31.53 689.94 0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "578.73 63.06 652.96 63.06 634.19 31.53 578.73 63.06"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "634.19 31.53 652.96 63.06 689.94 0 634.19 31.53"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "689.94 0 652.96 63.06 707.75 30.67 689.94 0"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "707.75 30.67 652.96 63.06 726.13 62.38 707.75 30.67"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "726.13 62.38 652.96 63.06 670.88 94.3 726.13 62.38"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "670.88 94.3 689.04 125.58 726.13 62.38 670.88 94.3"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "652.96 63.06 615.2 126.44 670.88 94.3 652.96 63.06"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "615.2 126.44 689.04 125.58 670.88 94.3 615.2 126.44"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "633.26 157.72 689.04 125.58 615.2 126.44 633.26 157.72"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "651.53 189.53 689.04 125.58 633.26 157.72 651.53 189.53"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "724.25 25.87 726.99 30.67 727.02 30.65 724.25 25.87"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "759.91 11.32 716.1 11.32 727.2 30.55 759.91 11.32 759.91 11.32"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "727.2 30.55 738 49.26 759.91 11.32 727.2 30.55"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "737.91 49.53 727.02 30.65 726.99 30.67 738 49.69 739.15 47.7 738 49.68 737.91 49.53"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "773.53 53.67 747.19 53.67 753.75 64.85 773.53 53.67"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "760.36 76.78 773.53 53.67 753.75 64.85 760.36 76.78"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "759.02 102.79 775.14 93.12 753.21 93.12 759.02 102.79"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "764.18 112.57 775.14 93.12 759.02 102.79 764.18 112.57"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "720.32 103.65 744.72 103.65 738.59 93.12 720.32 103.65"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "732.52 82.91 720.32 103.65 738.59 93.12 732.52 82.91"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "615.99 0 542.18 0 559.95 30.67 615.99 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,163.95c7.45.66,14.02,0,18.18-4.16,2.85-2.63,5.69-7.88,5.69-24.31,0-14.89,1.53-31.98,14.67-44.46,9.42-9.2,21.9-12.92,38.11-11.61v28.03c-8.1-.88-14.02.66-18.18,4.82-2.63,2.85-5.69,7.01-5.69,23.21,0,14.89-1.53,33.51-14.45,45.55-9.42,8.98-22.34,12.04-38.33,10.95v-28.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.26,191.76c-33.07,3.5-50.59-16.43-50.59-47.31V50.5h28.91v28.69h20.37v25.62h-20.37v39.86c0,15.77,7.23,21.68,21.68,20.81v26.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.12,194.61c-31.54,0-50.15-20.81-50.15-50.37v-65.05h28.91v65.92c0,6.35,2.19,21.46,21.24,21.46,12.7,0,21.9-8.98,21.9-21.46v-65.92h28.91v65.05c0,28.69-20.15,50.37-50.81,50.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.62,135.7c0,32.63-23.87,58.91-57.82,58.91s-58.04-26.28-58.04-58.91,24.31-58.91,53.88-58.91c13.36,0,24.31,4.16,33.07,13.14V29.04h28.91v106.66ZM338.8,103.5c-15.99,0-28.91,13.8-28.91,32.41s12.92,31.76,28.91,31.76,28.91-14.24,28.91-31.76-12.92-32.41-28.91-32.41Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.49,66.93v-16.21c0-8.1,6.57-14.45,14.67-14.45s14.45,6.35,14.45,14.45v16.21h-29.13ZM449.62,191.98h-28.91v-112.79h28.91v112.79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.65,135.7c0,33.73-25.62,58.91-56.94,58.91s-56.72-25.19-56.72-58.91,25.41-59.35,56.72-59.35,56.94,25.62,56.94,59.35ZM554.52,135.92c0-19.49-12.48-33.07-27.81-33.07s-27.81,13.58-27.81,33.07,12.48,32.19,27.81,32.19,27.81-13.14,27.81-32.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5b292c760f8d5882e157cb6e7f14d599.svg";
export { ForwardRef as ReactComponent };